import { useState, useEffect, useCallback } from "react";
import {
  Box,
  FormControl,
  Card,
  Table,
  Button,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TableRow,
  TablePagination,
  TextField,
  Autocomplete,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import Page from "./../../components/Page";
import Scrollbar from "./../../components/Scrollbar";
import { UserListHead } from "../../sections/@dashboard/user";
import HeaderBreadcrumbs from "./../../components/HeaderBreadcrumbs";
import { Download, Delete } from "@mui/icons-material";
import Loader from "src/components/Loader";
import "./TransactionsManagement.css";
import {
  GetTransactionDownload,
  GetTransactionDownloadFiles,
  GetTransactionListAction,
  ResetTransactionListAction,
  TransactionFilter,
  downloadTransactionFile,
  deleteAllFiles,
} from "src/redux/actions/TransactionsActions";
import moment from "moment";

export default function Transactions() {
  let params1 = null;
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [state, setState] = useState({
    email: "",
    phone: "",
  });

  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const formatFileSize = useCallback((size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  }, []);

  const { transaction_list, loading, transaction_download_files } = useSelector((state) => state.transaction_manager);
  console.log("transaction_download_files", transaction_download_files);

  useEffect(() => {
    state["typ"] = trannsStatusValue?.rstatus;
    if (state.phone !== "" || state.email !== "" || !!state.typ) {
      state["page"] = page + 1;
      state["size"] = rowsPerPage;
      dispatch(TransactionFilter(state));
    } else {
      dispatch(GetTransactionListAction(page + 1, rowsPerPage));
    }
    return () => dispatch(ResetTransactionListAction());
  }, [dispatch, page, rowsPerPage]);

  const handleDownload = () => {
    state["typ"] = trannsStatusValue?.rstatus;

    dispatch(GetTransactionDownload(state));
    if (!transaction_download_files?.length) {
      handlegetDownload();
    }
    setTimeout(() => {
      handlegetDownload();
    }, 10 * 1000);
  };

  const handleDeleteAll = () => {
    dispatch(deleteAllFiles());
    setOpenDialog(false);
    setOpen(false);
  };

  const handlegetDownload = () => {
    dispatch(GetTransactionDownloadFiles(state));
  };

  useEffect(() => {
    handlegetDownload();
  }, []);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const stateHandler = (key, value) => {
    state[key] = value;
    setState({ ...state });
  };

  const onChangType = (event, values) => {
    state["typ"] = values?.rstatus;
    setState({ ...state });
    setTrannsStatusValue(values);
  };

  const setReset = () => {
    setState({
      email: "",
      phone: "",
    });
    setTrannsStatusValue(0);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    state["typ"] = trannsStatusValue?.rstatus;
    if (state.phone !== "" || state.email !== "" || !!state.typ) {
      console.log("trannsStatusValue", trannsStatusValue);
      console.log("state", state);
      dispatch(TransactionFilter(state));
    } else {
      dispatch(GetTransactionListAction(page + 1, rowsPerPage));
    }
  };

  useEffect(() => {
    if (state.phone !== "" || state.email !== "" || !!state.typ) {
      console.log("trannsStatusValue", trannsStatusValue);
      console.log("state", state);
      dispatch(TransactionFilter(state));
    } else {
      dispatch(GetTransactionListAction(page + 1, rowsPerPage));
    }
  }, [state]);

  const tranns_status = [
    {
      rstatus: 0,
      name: "All",
    },
    {
      rstatus: "pending",
      name: "Pending",
    },
    {
      rstatus: "PAYMENT_ERROR",
      name: "Payment Error",
    },
    {
      rstatus: "PAYMENT_SUCCESS",
      name: "Completed",
    },
  ];

  const [trannsStatusValue, setTrannsStatusValue] = useState(tranns_status[0]);
  const [trannsStatusSubmit, setTrannsStatusSubmit] = useState(0);

  return (
    <Page title="Cricket Teams Manager">
      {loading ? <Loader /> : null}

      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Transactions"
          links={[{ name: "Dashboard", href: "/dashboard/app" }, { name: "Transactions" }]}
          action={[
            <Button onClick={() => handleDownload()} variant="contained">
              <Download />
              Download
            </Button>,

            <Container sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
              {transaction_download_files && transaction_download_files?.length ? (
                <Button
                  variant="outlined"
                  onClick={() => {
                    handlegetDownload();
                    setOpen(true);
                  }}
                >
                  View Available Downloads
                </Button>
              ) : (
                <></>
              )}

              <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <Box display="flex" justifyContent="space-between" alignItems="center" px={3} py={2}>
                  <DialogTitle sx={{ margin: 0, padding: 0 }}>Download History</DialogTitle>

                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => setOpenDialog(true)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Delete /> Delete All Files
                  </Button>
                </Box>
                <DialogContent>
                  <List>
                    {transaction_download_files &&
                      transaction_download_files.map((file, index) => (
                        <ListItem key={file._id} divider={index !== transaction_download_files.length - 1}>
                          <ListItemText
                            primary={file.fileName}
                            secondary={
                              <>
                                <Typography variant="body2" color="textSecondary">
                                  Size: {formatFileSize(file.fileSize)} | Date: {moment(file.createdAt).format("DD MMM YYYY, hh:mm A")}
                                </Typography>
                              </>
                            }
                          />
                          <ListItemSecondaryAction>
                            <Button variant="contained" color="primary" onClick={() => dispatch(downloadTransactionFile(file._id, file.fileName))}>
                              Download
                            </Button>
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))}
                  </List>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpen(false)} color="secondary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Confirmation Dialog */}
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                  <p>Are you sure you want to delete all transaction files? This action cannot be undone.</p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button onClick={handleDeleteAll} color="secondary">
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </Container>,
          ]}
        />
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <div className="search-filter-block">
                  <form
                    autoComplete="off"
                    onSubmit={handleFilterSubmit}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      flexWrap: "nowrap",
                    }}
                  >
                    <FormControl sx={{ minWidth: 200, marginRight: "10px" }}>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        defaultValue={trannsStatusValue}
                        options={tranns_status}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangType}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Type" placeholder="Select Type" />;
                        }}
                      />
                    </FormControl>

                    <FormControl sx={{ marginRight: "10px" }}>
                      <TextField onChange={({ target }) => stateHandler("email", target.value)} type="text" label="Email" variant="outlined" value={state.email} />
                    </FormControl>
                    <FormControl sx={{ marginRight: "10px" }}>
                      <TextField onChange={({ target }) => stateHandler("phone", target.value)} type="text" label="Phone" variant="outlined" value={state.phone} />
                    </FormControl>

                    <Button size="large" color="primary" className="btn" variant="contained" type="submit" sx={{ marginLeft: "20px" }}>
                      Search
                    </Button>

                    <Button
                      size="small"
                      color="primary"
                      className="btn"
                      sx={{
                        marginLeft: "20px",
                        border: "1px solid gray",
                        padding: "12px",
                      }}
                      onClick={() => setReset()}
                    >
                      Reset Filter
                    </Button>
                  </form>
                </div>
              </div>
              <Table>
                <UserListHead
                  rowCount={(transaction_list && transaction_list?.data?.data?.total_count) || 0}
                  headLabel={[
                    { id: "c_no", label: "Sr no.", alignRight: false },
                    { id: "txn_id", label: "Transaction Id", alignRight: false },
                    { id: "phone", label: "User Mobile", alignRight: false },
                    { id: "email", label: "User Email", alignRight: false },
                    { id: "type", label: "Cr/Dr", alignRight: false },
                    { id: "mode", label: "Mode", alignRight: false },
                    { id: "txn_type", label: "Transaction Type", alignRight: false },
                    { id: "atype", label: "Type", alignRight: false },
                    { id: "amount", label: "Amount", alignRight: false },
                    { id: "date", label: "Transaction Date", alignRight: false },
                  ]}
                />
                <TableBody>
                  {transaction_list &&
                    transaction_list?.data?.data?.transaction_list?.map((value, index) => {
                      return (
                        <TableRow hover key={index}>
                          <TableCell component="th" scope="row">
                            {page * rowsPerPage + (index + 1)}.
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.txid ? value?.txid : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.user?.phone ? value?.user?.phone : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.user?.email ? value?.user?.email : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.ttype ? value?.ttype.toUpperCase() : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.transactions_doc?.method ? value?.transactions_doc?.method : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.atype
                              ? value?.atype === "bns"
                                ? "Bonus"
                                : value?.atype === "bal"
                                ? "Balance"
                                : value?.atype === "bal_add"
                                ? "Balance Added"
                                : value?.atype === "win"
                                ? "Winning"
                                : "-"
                              : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.atype}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value?.amount ? value?.amount : "-"}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value.txdate
                              ? moment(value.txdate * 1000)
                                  .utc()
                                  .format("DD/MM/YY hh:mm A")
                              : "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 150, 200]}
            component="div"
            count={(transaction_list && transaction_list?.data?.data?.total_count) || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
